module.exports = __webpack_public_path__ + "static/media/wedding.90873510.jpg";